import request from '@/request/request'

/**
 * 获取公开招租列表
 * @param {} parameter 
 * @returns 
 */
export function listApplyProject (parameter) {
  return request({
    url: '/e-find-property/bidApply/listApplyProject',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除公开招租信息
 * @param {} parameter 
 * @returns 
 */
export function deleteApplyProject (parameter) {
  return request({
    url: '/e-find-property/bidApply/deleteApplyProject',
    method: 'delete',
    params: parameter
  })
}

/**
 * 获取意向发布列表
 * @param {} parameter 
 * @returns 
 */
export function listIntentProject (parameter) {
  return request({
    url: '/e-find-property/intentLease/listIntentProject',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除意向发布信息
 * @param {} parameter 
 * @returns 
 */
export function deleteIntentProject (parameter) {
  return request({
    url: '/e-find-property/intentLease/deleteIntentProject',
    method: 'delete',
    params: parameter
  })
}

/**
 * 房源信息选择权证详情
 * @param {} parameter 
 * @returns 
 */
export function listWarrantByHouseWebId (parameter) {
  return request({
    url: '/e-find-property/housingResources/listWarrantByHouseWebId',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取房源详情列表
 * @param {} parameter 
 * @returns 
 */
export function listSelectHouseDetailByBid (parameter) {
  return request({
    url: '/e-find-property/housingResources/listSelectHouseDetailByBid',
    method: 'post',
    data: parameter
  })
}

/**
 * 保存进场公开招租申请
 * @param {} parameter 
 * @returns 
 */
export function saveBidApply (parameter) {
  return request({
    url: '/e-find-property/bidApply/saveBidApply',
    method: 'post',
    data: parameter
  })
}

/**
 * 提交权证信息
 * @param {} parameter 
 * @returns 
 */
export function submitBidApply (parameter) {
  return request({
    url: '/e-find-property/bidApply/submitBidApply',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取权证详情
 * @param {} parameter 
 * @returns 
 */
export function getApplyDetail (parameter) {
  return request({
    url: '/e-find-property/bidApply/getApplyDetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 保存意向发布项目登记
 * @param {} parameter 
 * @returns 
 */
export function saveIntentLease (parameter) {
  return request({
    url: '/e-find-property/intentLease/saveIntentLease',
    method: 'post',
    data: parameter
  })
}

/**
 * 提交意向发布项目登记
 * @param {} parameter 
 * @returns 
 */
export function submitIntentLease (parameter) {
  return request({
    url: '/e-find-property/intentLease/submitIntentLease',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取意向发布详情
 * @param {} parameter 
 * @returns 
 */
export function getIntentDetail (parameter) {
  return request({
    url: '/e-find-property/intentLease/getIntentDetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 获取房源详情列表
 * @param {} parameter 
 * @returns 
 */
export function listSelectHouseDetailByIntent (parameter) {
  return request({
    url: '/e-find-property/housingResources/listSelectHouseDetailByIntent',
    method: 'post',
    data: parameter
  })
}